module.exports = {
	"config": {
		"siteTitle": "LightScript",
		"linkPrefix": "/",
		"docPages": [
			"/docs/",
			"/docs/getting-started/",
			"/docs/how-to-run/",
			"/docs/some-react-code/",
			"/docs/the-next-step/",
			"/docs/conclusion/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.lsc",
				"ext": "lsc",
				"name": "_template",
				"extname": ".lsc",
				"basename": "_template.lsc",
				"dirname": "",
				"stem": "_template",
				"path": "_template.lsc",
				"absolute": "/Users/alex/djcode/lightorg/lightscript/lightscript.org/_template.lsc",
				"isAbsolute": false
			},
			"requirePath": "_template.lsc",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/alex/djcode/lightorg/lightscript/lightscript.org/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "docs.md",
				"ext": "md",
				"name": "docs",
				"extname": ".md",
				"basename": "docs.md",
				"dirname": "docs",
				"stem": "docs",
				"path": "docs/docs.md",
				"absolute": "/Users/alex/djcode/lightorg/lightscript/lightscript.org/docs/docs.md",
				"isAbsolute": false
			},
			"requirePath": "docs/docs.md",
			"path": "/docs/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "index.lsc",
				"ext": "lsc",
				"name": "index",
				"extname": ".lsc",
				"basename": "index.lsc",
				"dirname": "docs",
				"stem": "index",
				"path": "docs/index.lsc",
				"absolute": "/Users/alex/djcode/lightorg/lightscript/lightscript.org/docs/index.lsc",
				"isAbsolute": false
			},
			"requirePath": "docs/index.lsc",
			"path": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "examples",
				"base": "_template.lsc",
				"ext": "lsc",
				"name": "_template",
				"extname": ".lsc",
				"basename": "_template.lsc",
				"dirname": "examples",
				"stem": "_template",
				"path": "examples/_template.lsc",
				"absolute": "/Users/alex/djcode/lightorg/lightscript/lightscript.org/examples/_template.lsc",
				"isAbsolute": false
			},
			"requirePath": "examples/_template.lsc",
			"templatePath": "/examples/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "examples",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "examples",
				"stem": "index",
				"path": "examples/index.md",
				"absolute": "/Users/alex/djcode/lightorg/lightscript/lightscript.org/examples/index.md",
				"isAbsolute": false
			},
			"requirePath": "examples/index.md",
			"path": "/examples/",
			"data": {
				"title": "Modules used on this site"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "faq",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "faq",
				"stem": "index",
				"path": "faq/index.md",
				"absolute": "/Users/alex/djcode/lightorg/lightscript/lightscript.org/faq/index.md",
				"isAbsolute": false
			},
			"requirePath": "faq/index.md",
			"path": "/faq/",
			"data": {
				"title": "FAQ"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.lsc",
				"ext": "lsc",
				"name": "index",
				"extname": ".lsc",
				"basename": "index.lsc",
				"dirname": "",
				"stem": "index",
				"path": "index.lsc",
				"absolute": "/Users/alex/djcode/lightorg/lightscript/lightscript.org/index.lsc",
				"isAbsolute": false
			},
			"requirePath": "index.lsc",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0